import * as types from "./actionTypes";
import sessionApi from "../api/shared/sessionApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import { showToastrError } from "../util/toastr";
import redirector from "../util/redirector";

export function setActiveSportclubId(sportclubId, transactionId, readOnly, isNew) {
	return {
		type: types.ACTIVE_SPORTCLUBID_SET,
		body: { sportclubId: sportclubId, transactionId: transactionId, readOnly: readOnly, isNew: isNew }
	};
}

export function setActiveTransactionId(transactionId) {
	return {
		type: types.ACTIVE_TRANSACTIONID_SET,
		body: transactionId
	};
}

export function setSportclubSearchModel(searchModel) {
	return {
		type: types.SPORTCLUBSEARCHMODEL_SET,
		body: { sportclubSearchModel: searchModel }
	};
}

export function setActivatiePopupShown() {
	return {
		type: types.ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN
	};
}

export function resetActivatiePopupShown() {
	return {
		type: types.RESET_ACTIVATE_SPORTORGANISATIE_POPUP_SHOWN
	};
}

export function setHasUnsavedChanges(hasUnsavedChanges) {
	return {
		type: types.SET_UNSAVED_CHANGES,
		body: hasUnsavedChanges
	};
}

export function setUserType(userType) {
	return {
		type: types.USERTYPE_SET,
		body: userType
	};
}

export function setActiveOrganisatieNiveau(organisatieType) {
	return {
		type: types.ACTIVE_ORGANISATIENIVEAU_SET,
		body: organisatieType
	};
}